enum EventListeners {
  GET_REACT_COMPONENT = "GET_REACT_COMPONENT",
  ADD_PAGE = "addPage",
  STEP_DOWN_PAGE = "stepDownPage",
  SELECT_PAGE = "selectPage",
  ADD_CUSTOM_ACTIONS = "addcustomActions",
  ADD_MODAL_POPUP = "addModalPopup"
}
export default EventListeners;
